import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Stat,
  StatLabel,
  StatNumber,
  Heading,
  Text,
} from "@chakra-ui/react";

const StatPanel = () => {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await fetch("https://pi-chart-backend.onrender.com/api/price");
        const data = await res.json();
        console.log("✅ Stats received:", data); // 🐞 Debug log
        setStats(data);
      } catch (err) {
        console.error("❌ Failed to fetch stats:", err);
        setError("Could not load market data.");
      }
    };

    fetchStats();
  }, []);

  if (error) {
    return (
      <Box textAlign="center" color="red.400" mt={6}>
        <Text>{error}</Text>
      </Box>
    );
  }

  if (!stats) {
    return (
      <Box textAlign="center" color="gray.300" mt={6}>
        <Text>📡 Loading Pi/USDT stats...</Text>
      </Box>
    );
  }

  return (
    <Box mt={10}>
      <Heading as="h2" size="lg" mb={4}>
        📊 Live Pi/USDT Market Stats
      </Heading>
      <Grid templateColumns="repeat(auto-fit, minmax(150px, 1fr))" gap={6}>
        <Stat bg="gray.800" p={4} borderRadius="xl">
          <StatLabel>PRICE</StatLabel>
          <StatNumber>${stats.price.toFixed(5)}</StatNumber>
        </Stat>
        <Stat bg="gray.800" p={4} borderRadius="xl">
          <StatLabel>VOLUME</StatLabel>
          <StatNumber>{stats.volume.toLocaleString()}</StatNumber>
        </Stat>
        <Stat bg="gray.800" p={4} borderRadius="xl">
          <StatLabel>HIGH</StatLabel>
          <StatNumber>${stats.high}</StatNumber>
        </Stat>
        <Stat bg="gray.800" p={4} borderRadius="xl">
          <StatLabel>LOW</StatLabel>
          <StatNumber>${stats.low}</StatNumber>
        </Stat>
        <Stat bg="gray.800" p={4} borderRadius="xl">
          <StatLabel>CHANGE</StatLabel>
          <StatNumber>{stats.change}%</StatNumber>
        </Stat>
      </Grid>
    </Box>
  );
};

export default StatPanel;
